import * as moment from 'moment';
import { RelationshipType } from './Enums';

export const momentDateFormat = 'YYYY-MM-DD';
export const formatDate = (dateString: string) => moment(dateString).format(momentDateFormat);

export const creditCardDateFormat = 'MM-YY';
export const formatCreditCardExpiration = (dateString: string) =>
    moment(dateString).format(creditCardDateFormat);

export const relationshipTypeDisplay = (typ: RelationshipType) => {
    switch (typ) {
        case RelationshipType.Minor:
            return 'Minor';
        case RelationshipType.Roommate:
            return 'Roommate';
        case RelationshipType.Spouse:
            return 'Spouse';
        case RelationshipType.OtherGuest:
            return 'Other Guest';
        case RelationshipType.Unknown:
        default:
            return 'Unknown';
    }
};



// WEBPACK FOOTER //
// ./src/utilities/formatting.ts